import React from 'react';

const PoliticaPrivacidad = () => (
  <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
    <h1>Política de Privacidad y Términos de Uso</h1>
    <h2>Política de Privacidad</h2>
    <p>
      Ascensos App Vortex respeta la privacidad de sus usuarios y se compromete a proteger sus datos personales. Al utilizar la aplicación, aceptas los siguientes términos y condiciones.
    </p>
    <h3>1. Datos que recopilamos</h3>
    <ul>
      <li><b>Identificadores de usuario:</b> como la cuenta de Google para autenticación y vinculación de dispositivos.</li>
      <li><b>Acceso al micrófono:</b> únicamente para funciones de reconocimiento de voz. No se almacenan grabaciones de audio en nuestros servidores.</li>
      <li><b>Almacenamiento interno:</b> para guardar configuraciones, preferencias y progreso del usuario localmente en el dispositivo.</li>
    </ul>
    <h3>2. Uso de la información</h3>
    <ul>
      <li>Los datos se utilizan exclusivamente para el funcionamiento de la app y la mejora de la experiencia del usuario.</li>
      <li>No compartimos información personal con terceros, salvo servicios necesarios para el funcionamiento (por ejemplo, Google).</li>
    </ul>
    <h3>3. Derechos del usuario</h3>
    <ul>
      <li>Puedes solicitar acceso, rectificación o eliminación de tus datos escribiendo a <a href="mailto:ascensosappvortex@gmail.com">ascensosappvortex@gmail.com</a>.</li>
    </ul>
    <h3>4. Seguridad</h3>
    <ul>
      <li>Implementamos medidas de seguridad para proteger tus datos personales.</li>
    </ul>
    <h3>5. Cambios en la política</h3>
    <ul>
      <li>Nos reservamos el derecho de modificar esta política. Los cambios serán notificados en la app.</li>
    </ul>
    <hr />
    <h2>Términos y Condiciones de Uso</h2>
    <ol>
      <li><b>Introducción</b><br />
        Estos Términos y Condiciones (en adelante, los "Términos") rigen el uso de la aplicación Ascensos App Vortex, diseñada para brindar acceso a módulos educativos sobre conocimientos generales y específicos. Al descargar y utilizar la aplicación, el usuario acepta que su dispositivo se vincula con su cuenta de usuario de Google y se compromete a cumplir con estos Términos y será el único responsable de los posibles problemas legales que existan por el mal uso que el mismo usuario le dé a la información de la aplicación.
      </li>
      <li><b>Contenidos de la aplicación</b>
        <ul>
          <li><b>2.1.</b> Material adquirido de fuentes públicas y de conocimiento general: La aplicación incluye información basada en leyes, reglamentos y documentos oficiales de acceso público, así como de términos marítimos, Publicaciones e Historia proporcionada en la red de internet.</li>
          <li><b>2.2.</b> Material de terceros: Algunos módulos contienen preguntas o materiales obtenidos de fuentes accesibles públicamente, incluidas páginas web dedicadas a realizar u ofrecer servicios quizz o cuestionarios. Estos contenidos son utilizados para realizar los test de esta aplicación.</li>
        </ul>
      </li>
      <li><b>Limitación de responsabilidad</b>
        <ul>
          <li><b>3.1.</b> Ascensos App VORTEX no garantiza la exactitud, actualidad o exhaustividad de la información proporcionada y no será responsable por el uso indebido o cualquier cuestión derivada de las acciones realizadas por los particulares con la aplicación.</li>
          <li><b>3.2.</b> La aplicación no está afiliada ni respaldada por las páginas o aplicaciones mencionadas.</li>
        </ul>
      </li>
      <li><b>Uso permitido</b>
        <ul>
          <li><b>4.1.</b> La aplicación es para uso personal y educativo, con la finalidad de proporcionar al usuario herramientas para mejorar su nivel académico en temas que le servirán para aplicar los exámenes de promoción que realice su institución.</li>
          <li><b>4.2.</b> Queda prohibido reproducir, distribuir o modificar cualquier contenido de la aplicación sin el consentimiento previo y por escrito del desarrollador.</li>
        </ul>
      </li>
      <li><b>Propiedad intelectual</b><br />
        Los derechos de propiedad intelectual sobre el diseño, funcionalidad y elementos originales de la aplicación son propiedad del equipo desarrollador.
      </li>
      <li><b>Actualización y modificaciones</b><br />
        El equipo desarrollador se reserva el derecho de modificar estos Términos en cualquier momento. Las actualizaciones serán notificadas dentro de la aplicación.
      </li>
      <li><b>Ley aplicable y jurisdicción</b><br />
        La información proporcionada en Ascensos App Vortex es tomada de fuentes abiertas y accesibles públicamente. Por lo tanto, el equipo de desarrolladores no garantiza la validez, actualidad o exactitud de dicha información y no se responsabiliza por su uso ni por cualquier consecuencia derivada de ello.<br /><br />
        Al instalar y utilizar la aplicación, incluyendo la adquisición de cualquier suscripción, el usuario acepta que será el único responsable del uso y destino de la información proporcionada en la aplicación. Ante cualquier problema legal, la responsabilidad recae exclusivamente en el usuario.<br /><br />
        La aplicacion no guarda ningun tipo de informacion personal que el usuario utiilce para realizar sus cuestionarios o sus audios, nada de informacion propia del usuario es subida o mantenida en nuestros servidores.
        Cualquier disputa derivada del uso de la aplicación será resuelta por los particulares en los tribunales competentes de la República Mexicana.
      </li>
    </ol>
  </div>
);

export default PoliticaPrivacidad; 